<template>
  <div class="aiAvatarSelectionSource" v-if="isAvatarEnabled">
      <transition-group name="zoom" v-show="!isOptionPanelOpen">
        <AIAvatarSlideTemplateSelectionButton v-show="mustShow" :key="'avatarSlideTemplateSelectionButton'" />
        <AIAvatarSelectionButton v-show="mustShow" :key="'avatarSelectionButton'" />
        <AIAvatarBackgroundSelectionButton v-show="mustShow" :key="'avatarBackgroundSelectionButton'" />
      </transition-group>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {FilterVideoType} from '@/enum/FilterVideoEnum';
import {SourceVideoType} from '@/enum/SourceVideoEnum';
import store from '@/store';
import AIAvatarSelectionButton from "@/components/recorder/aiAvatar/buttons/AIAvatarSelectionButton.vue";
import AIAvatarBackgroundSelectionButton
  from "@/components/recorder/aiAvatar/buttons/AIAvatarBackgroundSelectionButton.vue";
import AIAvatarSlideTemplateSelectionButton
  from "@/components/recorder/aiAvatar/buttons/AIAvatarSlideTemplateSelectionButton.vue";
import { ScriptSlideLayout, Slide } from "@/store/slides2Video/slides2VideoModels";


@Component({
  components: {
    AIAvatarSlideTemplateSelectionButton,
    AIAvatarBackgroundSelectionButton,
    AIAvatarSelectionButton,
  },
  computed: {},
})
export default class StickerLayoutSource extends Vue {

  private mustShow=false;

  get isOptionPanelOpen(){
    return store.getters.isPanelOptionOpen
  }


  get isAvatarEnabled():boolean{
    if(!this.isAIAvatarAuthorized){
      return false;
    }
    if(this.timeRemaining<=0){
      return false;
    }
    return true;
  }

  get timeRemaining(){
    return store.getters.getAvatarAIremaining;
  }
  get isAIAvatarAuthorized(){
    return store.getters.isAvatarAI;
  }


  get currentSlide(): Slide | null {
    if (store.getters.getCurrentSlideIndex > -1) {
      return store.getters.slides[store.getters.getCurrentSlideIndex];
    }
    return null;
  }

  get isSlideSelected(){
    return this.currentSlide?.layout===ScriptSlideLayout.SLIDE || store.getters.getAvatarScriptSlideLayout===ScriptSlideLayout.SLIDE;
  }

  public mounted() {
      this.mustShow = true;
  }

}
</script>
<style lang="scss" scoped>
.aiAvatarSelectionSource{
  width: 32px;
  min-height: 32px;
}

</style>
